export const websiteLink = '#';
export const tgLink = '#';
export const xLink = '#';
export const PhysicalProductsStore ='https://app.aicm.store/'
export const VirtualProductsStore = 'https://app.aicm.store/'
export const VirtualServicesStore = 'https://app.aicm.store/'
export const PrivacyPolicy = 'https://aicm-store.gitbook.io/whitepaper/legal-and-security/privacy-policy'
export const TermsofUse ='https://aicm-store.gitbook.io/whitepaper/legal-and-security/terms-of-service'
export const dexScreenerLink = 'https://dexscreener.com/ethereum/0x52ad69cd77bf8a3d5846012adb84707bd0b9c4e8';
export const dexToolsLink = '#';
export const whitepaper = 'https://aicm-store.gitbook.io/whitepaper'
export const Coingecko ='https://www.coingecko.com/en/coins/aicm-marketplace';
export const CoinMarketCap ='https://coinmarketcap.com/currencies/ai-crypto-marketplace/'
export const uniSwapLink = 'https://app.uniswap.org/swap?outputCurrency=0x87904bE82BC1C29E94a0b99474d183B4e08a7E47&chain=ethereum';
export const buySellTax = '0/0';
export const supply = 'TBA';
export const CA = '0x87904bE82BC1C29E94a0b99474d183B4e08a7E47';
export const PhysicalGoods ='https://aicm-store.gitbook.io/whitepaper/platform-expansion-plans/physical-goods-and-merchandise';
export const DigitalGoods ='https://aicm-store.gitbook.io/whitepaper/platform-expansion-plans/crypto-centric-digital-services';
export const services ='https://aicm-store.gitbook.io/whitepaper/platform-expansion-plans/crypto-centric-digital-services';
